module.exports = __webpack_public_path__ + "img/2020_12_26_toad.445ce0de.jpg";